__webpack_require__.p = "/staticky-obsah-fe/";